import { render, staticRenderFns } from "./vehicle_trip_history.vue?vue&type=template&id=5abff2ca&scoped=true&"
import script from "./vehicle_trip_history.vue?vue&type=script&lang=js&"
export * from "./vehicle_trip_history.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_trip_history.vue?vue&type=style&index=0&lang=css&"
import style1 from "./vehicle_trip_history.vue?vue&type=style&index=1&id=5abff2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abff2ca",
  null
  
)

export default component.exports